/* eslint-disable complexity */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'roundoffDecimal'
})
export class RoundoffDecimalPipe implements PipeTransform
{

	transform(value: string | number | undefined, decimalPlaces: number): string
	{
		if (value === null || value === undefined || value === '') return '';
		const input = typeof value === 'number' ? value.toString() : value;
		const match = RegExp(/^([\d.-]+)([^\d.-]*)$/).exec(input);
		if (!match)
		{
			return input;
		}

		const numericPart = match[1];
		const symbol = match[2] || '';

		const numberValue = parseFloat(numericPart);

		if (isNaN(numberValue))
		{
			return input;
		}

		const factor = Math.pow(10, decimalPlaces);
		const scaledValue = numberValue * factor;
		const scaledString = scaledValue.toFixed(decimalPlaces + 1);
		const thirdDecimal = scaledString.charAt(scaledString.length - 1);

		let roundedValue: number;

		if (thirdDecimal === '5')
		{
			roundedValue = Math.floor(scaledValue) / factor;
		}
		else
		{
			roundedValue = Math.round(scaledValue) / factor;
		}

		if (Number.isInteger(roundedValue))
		{
			return `${roundedValue}${symbol}`;
		}

		let result = roundedValue.toFixed(decimalPlaces);

		if (result.indexOf('.') !== -1)
		{
			result = result.replace(/\.?0+$/, '');
		}
		return `${result}${symbol}`;
	}

}
